import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AgCustomHeaderComponent } from 'src/app/shared/components/ag-grid/ag-custom-header/ag-custom-header.component';
import { AgGridI, AgGridPaginationConfig } from 'src/app/shared/components/ag-grid/ag-grid.model';
import { AgGridImportBOMMap, AgGridImportCodecrosswalkMap, AgGridImportCompaniesMap, AgGridImportVendorMap } from "../map-tab/map-tab.model";
import { ImportDocumentsService } from '../../import-documents.service'
import { COMPANY_REQUIRED_VALUES, InsertUpdateImportDocumnets } from '../../import-documents.model';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { Subscription, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Button, CurrentTab, RoutePath } from 'src/app/shared/model/enum';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { CodeCrosswalkService } from 'src/app/components/admin/code-crosswalk/code-crosswalk.service';
import { ProgressHelperService } from '../step-progressbar/progress-helper.service';
import { UploadDocumentsComponent } from '../../../crm/companies/pages/company-info-tabs/pop-ups/upload-documents/upload-documents.component';
import { SendDataService } from '../../../../shared/services/send-data.service';
import { ModalPopupSize } from '../../../../shared/model/common.model';
import { UnmappedPopUpComponent } from '../../../../shared/components/unmapped-pop-up/unmapped-pop-up.component';
import { ImportMappingService } from '../../../../shared/import/import-mapping.service';
import {
  applyAutoMapToRows,
  filterMappableSystemColumns,
  filterUnmappedUploadedColumns,
  IMPORT_MODULE_REQUIRED_FIELDS,
  IMPORT_MODULE_SYSTEM_COLUMNS,
  isImportModelProvidedField,
} from '../../../../shared/import/import-field-definitions';
import { ImportTemplateSource } from '../../../../shared/model/enum';
import { DetailsTabComponent } from '../details-tab/details-tab.component';

@Component({
  selector: 'app-map-tab',
  templateUrl: './map-tab.component.html',
  styleUrls: ['./map-tab.component.scss']
})
export class MapTabComponent implements OnInit, OnDestroy {
  enumButtonName = Button
  insertUpdateImportDocumnets = new InsertUpdateImportDocumnets();
  agGridPaginationConfig = new AgGridPaginationConfig();
  dataModel: AgGridI;
  private gridApi;
  private gridColumnApi;
  public components: {
    [p: string]: any;
  } = {
      agColumnHeader: AgCustomHeaderComponent,
    }
  sub: Subscription
  required = IMPORT_MODULE_REQUIRED_FIELDS[ImportTemplateSource.Companies];
  requiredVendor = IMPORT_MODULE_REQUIRED_FIELDS[ImportTemplateSource.Vendor];
  requiredBOM = IMPORT_MODULE_REQUIRED_FIELDS[ImportTemplateSource.Requirement];
  isLoading: boolean = false;

  rowData: any[] = [];
  flexHeight;
  isRecall: boolean = false;
  columnList: [];
  mapList = [];
  codecrosswalkSystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.CodeCrosswalk];
  staticSystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.Companies];
  staticVendorSystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.Vendor];
  staticBOMSystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.Requirement];
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  unmappedUploadedColumns: string[] = [];
  uploadedHeadersFromFile: string[] = [];
  requiredMissingCount = 0;
  currentTab: string;
  sourceId: number = 1;
  routeUrl: string;
  routePath = RoutePath;
  tabName = CurrentTab;
  mapTab: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    public importDocumentsService: ImportDocumentsService,
    private router: Router,
    public toaster: ToastrService,
    public commonService: CommonService,
    public tabsService: TabsService,
    public sendDataService: SendDataService,
    public codeCrosswalkService: CodeCrosswalkService,
    private progressHelper: ProgressHelperService,
    private importMappingService: ImportMappingService,

  ) {
    this.routeUrl = this.router.url;
    this.importDocumentsService.mapTabShow
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) {
          this.importDocumentsService.indexActive = 0;
          this.mapTab = true;
        } else {
          this.mapTab = false;
        }
      });

    this.sub = this.importDocumentsService.dataPassAccordingToTrackingBar
      .pipe(
        takeUntil(this.destroy$),
        filter(() => this.importDocumentsService.indexActive === 0 && this.mapTab)
      )
      .subscribe(() => {
        this.insertUpdateImportDocumnets = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
        this.getMapToList();
      });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.addEventListener('cellValueChanged', () => {
      this.recalculateUnmappedColumns();
      this.importDocumentsService.isMappingChanged.next(true);
    });
  }

  recalculateUnmappedColumns() {
    const sourceHeaders = this.uploadedHeadersFromFile?.length ? this.uploadedHeadersFromFile : this.mapList;
    if (!sourceHeaders?.length) {
      const firstRow = this.rowData?.[0];
      if (firstRow?.map?.length) {
        this.mapList = firstRow.map;
      }
    }
    const headers = this.uploadedHeadersFromFile?.length ? this.uploadedHeadersFromFile : this.mapList;
    if (!headers?.length) return;

    const mappedColumns: string[] = [];
    let unmappedColumnsCount = 0;
    this.gridApi?.forEachNode((node) => {
      if (node.data) {
        const mappedCol = node.data.mappedColumn?.trim();
        const isMapped = !!mappedCol && mappedCol !== '-Select Field-';
        node.data.status = isMapped;
        if (isMapped) {
          mappedColumns.push(mappedCol);
        } else {
          unmappedColumnsCount++;
        }
      }
    });
    this.importDocumentsService.count = unmappedColumnsCount;
    this.unmappedUploadedColumns = filterUnmappedUploadedColumns(
      headers,
      this.getImportSourceId(),
      mappedColumns
    );
  }

  ngOnInit(): void {
    this.tabsService.currentTab.subscribe(res => {
      if (res !== undefined) {
        this.currentTab = res;
      }
    })

    this.importDocumentsService.mapValidation.next(true);
    this.commonService.headerHeight.subscribe(res => {
      if (window.innerWidth < 1072) {
        this.flexHeight = "calc(98vh - 300px - " + res + "px" + ")"
      } else {
        this.flexHeight = "calc(98vh - 293px - " + res + "px" + ")"
      }
      if (this.routeUrl === this.routePath.CODECROSSWALK_ROUTEPATH) {
        this.flexHeight = "calc(100vh - 416px - " + res + "px)";
      }
    })
    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      this.dataModel = AgGridImportCodecrosswalkMap;
      this.fillList()
    } else if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      this.dataModel = AgGridImportVendorMap;
    } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
      this.dataModel = AgGridImportBOMMap;
    } else {
      this.dataModel = AgGridImportCompaniesMap;
    }
    // this.getMapToList()
  }

  getMapToList() {
    // Clear previous data to ensure fresh mapping for new files
    this.rowData = [];
    this.mapList = [];
    this.unmappedUploadedColumns = [];

    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      if (this.insertUpdateImportDocumnets?.importCodeCrosswalkModel?.file) {
        const data = { file: this.insertUpdateImportDocumnets?.importCodeCrosswalkModel?.file ?? '' }
        this.importDocumentsService.mapToList(data).subscribe(res => {
          this.mapList = res?.response ?? [];
          if (this.insertUpdateImportDocumnets?.importCodeCrosswalkModel?.mappingTemplateId) {
            this.fillListById()
          } else {
            this.fillList();
          }
        })
      }
    } else if (this.insertUpdateImportDocumnets?.importCompanyModel?.file) {
      const data = { file: this.insertUpdateImportDocumnets?.importCompanyModel?.file ?? '' }
      this.importDocumentsService.mapToList(data).subscribe(res => {
        this.mapList = res?.response ?? [];
        if (this.insertUpdateImportDocumnets?.importCompanyModel?.mappingTemplateId) {
          this.fillListById()
        } else {
          this.fillList();
        }
      })
    } else if (this.currentTab == this.tabName.IMPORT_BOM_TAB) {
      if (this.insertUpdateImportDocumnets?.importModel?.file) {
        const data = { file: this.insertUpdateImportDocumnets?.importModel?.file ?? '' }
        this.importDocumentsService.mapToList(data).subscribe(res => {
          this.mapList = res?.response ?? [];
          if (this.insertUpdateImportDocumnets?.importModel?.mappingTemplateId) {
            this.fillListById()
          } else {
            this.fillList();
          }
        })
      }
    }
  }

  fillList() {
    let id = this.insertUpdateImportDocumnets?.importCompanyModel?.mappingTemplateId ?? ''
    // Only skip if we have mapped data with the same template ID and the mapList matches current upload
    let hasMappedColumn = this.rowData?.some(x => !!x.mappedColumn && x.templateId === id && x.map?.length === this.mapList?.length) ?? false;
    if (hasMappedColumn) return

    this.importDocumentsService.getImportDropDownList().subscribe(res => {
      this.isLoading = true;
      this.isRecall = res.isSuccess;
      this.insertUpdateImportDocumnets.tempTemplateMappingColumns = '';
      if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
        this.rowData = this.codecrosswalkSystemColumns.map(systemColumn => ({ systemColumn }));
        this.rowData.map((a) => {
          a.map = this.mapList;
          a.templateId = a?.templateId ?? '';
          a.id = a?.id ?? '';
          a.status = false;
          a.mappedColumn = '';
        })
        this.importDocumentsService.submit = this.importDocumentsService.checkRequiredValueCodecrosswalk(this.rowData)
      } else {
        if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
          this.rowData = filterMappableSystemColumns(this.staticVendorSystemColumns, ImportTemplateSource.Vendor)
            .map(systemColumn => ({ systemColumn }));
        } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
          this.rowData = filterMappableSystemColumns(this.staticBOMSystemColumns, ImportTemplateSource.Requirement)
            .map(systemColumn => ({ systemColumn }));
        }
        else {
          this.rowData = filterMappableSystemColumns(this.staticSystemColumns, ImportTemplateSource.Companies)
            .map(systemColumn => ({ systemColumn }));
        }
        this.rowData.map((a) => {
          a.map = this.mapList;
          a.templateId = a?.templateId ?? '';
          a.id = a?.id ?? '';
          a.status = false;
          a.mappedColumn = '';
        })

        if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
          this.rowData.map((a) => {
            if (this.codecrosswalkSystemColumns.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          });
        } else if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
          this.rowData.map((a) => {
            if (this.requiredVendor.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          });
        } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
          this.rowData.map((a) => {
            if (this.requiredBOM.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          });
        } else {
          this.rowData.map((a) => {
            if (COMPANY_REQUIRED_VALUES.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          });
        }

        if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
          this.importDocumentsService.submit = this.importDocumentsService.checkVendorRequiredValue(this.rowData)
        } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
          this.importDocumentsService.submit = this.importDocumentsService.checkBOMRequiredValue(this.rowData)
        } else {
          this.importDocumentsService.submit = this.importDocumentsService.checkRequiredValue(this.rowData)
        }
      }
      if (this.rowData?.length > 0) {
        this.isLoading = false;
        this.runAutoMap();
      }
    })
  }

  fillListById() {
    let id = this.insertUpdateImportDocumnets?.importCompanyModel?.mappingTemplateId ?? ''
    // Only skip if we have mapped data with the same template ID and the mapList matches current upload
    let hasMappedColumn = this.rowData?.some(x => !!x.mappedColumn && x.templateId === id && x.map?.length === this.mapList?.length) ?? false;
    if (hasMappedColumn) return

    this.isLoading = true;
    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) { this.sourceId = ImportTemplateSource.CodeCrosswalk }
    else if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) { this.sourceId = ImportTemplateSource.Vendor }
    else if (this.routeUrl === this.routePath.IMPORTBOM_ROUTEPATH) { this.sourceId = ImportTemplateSource.Requirement }
    this.importDocumentsService.getImportCompanyTemplateById(this.currentTab == this.tabName.CODECROSSWALK_TAB ? (this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId) : (this.currentTab == this.tabName.IMPORT_BOM_TAB ? (this.insertUpdateImportDocumnets.importModel.mappingTemplateId) : (this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId)), this.sourceId)
      .subscribe(res => {
        this.insertUpdateImportDocumnets.tempTemplateMappingColumns = '';
        this.rowData = (res?.response?.templateMappingColumns ?? [])
          .filter((row) => !isImportModelProvidedField(this.sourceId, row.systemColumn));
        this.rowData.map((a) => {
          a.map = this.mapList
        });
        if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
          this.rowData.map((a) => {
            if (this.codecrosswalkSystemColumns.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          })
        } else if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
          this.rowData.map((a) => {
            if (this.requiredVendor.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          })
        } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
          this.rowData.map((a) => {
            if (this.requiredBOM.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          })
        }
        else {
          this.rowData.map((a) => {
            if (COMPANY_REQUIRED_VALUES.includes(a.systemColumn)) {
              a.isRequired = true;
            } else {
              a.isRequired = false;
            }
          })
        }
        this.insertUpdateImportDocumnets.tempTemplateMappingColumns = JSON.stringify(this.rowData);
        this.importDocumentsService.isMappingChanged.next(false);
        this.insertUpdateImportDocumnets.templateData = res?.response;
        if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
          this.importDocumentsService.submit = this.importDocumentsService.checkRequiredValueCodecrosswalk(this.rowData);
        } else {
          if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
            this.importDocumentsService.submit = this.importDocumentsService.checkVendorRequiredValue(this.rowData);
          } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
            this.importDocumentsService.submit = this.importDocumentsService.checkBOMRequiredValue(this.rowData);
          } else {
            this.importDocumentsService.submit = this.importDocumentsService.checkRequiredValue(this.rowData);
          }
        }
        if (this.rowData?.length > 0) {
          this.isLoading = false;
          this.runAutoMap();
        }
      })
  }

  private getImportSourceId(): number {
    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) return ImportTemplateSource.CodeCrosswalk;
    if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) return ImportTemplateSource.Vendor;
    if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) return ImportTemplateSource.Requirement;
    return ImportTemplateSource.Companies;
  }

  private getImportFile(): string {
    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      return this.insertUpdateImportDocumnets?.importCodeCrosswalkModel?.file ?? '';
    }
    if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
      return this.insertUpdateImportDocumnets?.importModel?.file ?? '';
    }
    return this.insertUpdateImportDocumnets?.importCompanyModel?.file ?? '';
  }

  private runAutoMap() {
    const file = this.getImportFile();
    if (!file || !this.rowData?.length) return;

    this.importMappingService.autoMapFields(file, this.getImportSourceId()).subscribe((res: any) => {
      if (!res?.isSuccess || !res?.response) return;
      const headerOptions = this.mapList?.length ? this.mapList : (res.response.uploadedHeaders ?? []);
      this.uploadedHeadersFromFile = res.response.uploadedHeaders ?? headerOptions;
      const applied = applyAutoMapToRows(this.rowData, res.response, headerOptions, this.getImportSourceId());
      this.rowData = applied.rowData;
      this.unmappedUploadedColumns = applied.unmappedColumns;
      if (!this.mapList || !this.mapList.length) {
        this.mapList = headerOptions;
      }
      this.requiredMissingCount = res.response.requiredMissingCount ?? 0;

      // Enforce isRequired flag based on constants to prevent backend from incorrectly overwriting it
      if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
        this.rowData.map((a) => {
          a.isRequired = this.codecrosswalkSystemColumns.includes(a.systemColumn);
        });
      } else if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
        this.rowData.map((a) => {
          a.isRequired = this.requiredVendor.includes(a.systemColumn);
        });
      } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
        this.rowData.map((a) => {
          a.isRequired = this.requiredBOM.includes(a.systemColumn);
        });
      } else {
        this.rowData.map((a) => {
          a.isRequired = COMPANY_REQUIRED_VALUES.includes(a.systemColumn);
        });
      }

      this.gridApi?.setRowData?.(this.rowData);
      this.recalculateUnmappedColumns();
      if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
        this.importDocumentsService.submit = this.importDocumentsService.checkRequiredValueCodecrosswalk(this.rowData);
      } else if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
        this.importDocumentsService.submit = this.importDocumentsService.checkVendorRequiredValue(this.rowData);
      } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
        this.importDocumentsService.submit = this.importDocumentsService.checkBOMRequiredValue(this.rowData);
      } else {
        this.importDocumentsService.submit = this.importDocumentsService.checkRequiredValue(this.rowData);
      }
    });
  }

  close() {
    this.codeCrosswalkService.valuePopup.next(true)
  }

  prepareMappingData(): boolean {
    const list: any = [];
    this.gridApi.forEachNode((a) => {
      list.push(a.data);
    });

    list.map((b) => {
      if (b.mappedColumn === b.systemColumn) {
        b.status = true;
      }
    });

    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      list.map((a) => {
        a.isRequired = this.codecrosswalkSystemColumns.includes(a.systemColumn);
      });
    } else if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      list.map((a) => {
        a.isRequired = this.requiredVendor.includes(a.systemColumn);
      });
    } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
      const qtyRow = list?.find((x: any) => x.systemColumn === 'Qty');
      if (qtyRow && qtyRow.systemColumn !== qtyRow.mappedColumn) {
        this.importDocumentsService.mapValidation.next(false);
        this.toaster.error(`Mismatch in Qty column.`, 'Mapping Error');
        return false;
      }

      const otherFields = ['Additional Quantity', 'In House Requirement', 'Project Approved', 'Manufacturer COC', 'Company COC', 'Required Images', 'Required Inspection Report'];
      const mismatchedColumns = list
        ?.filter((x: any) => otherFields.includes(x.systemColumn) && x.mappedColumn !== '' && x.systemColumn !== x.mappedColumn)
        .map((x: any) => x.systemColumn);
      if (mismatchedColumns?.length > 0) {
        this.importDocumentsService.mapValidation.next(false);
        this.toaster.error(`Mismatch in ${mismatchedColumns} column.`, 'Mapping Error');
        return false;
      }
      list.map((a) => {
        a.isRequired = this.requiredBOM.includes(a.systemColumn);
      });
    } else {
      list.map((a) => {
        a.isRequired = COMPANY_REQUIRED_VALUES.includes(a.systemColumn);
      });
    }

    this.insertUpdateImportDocumnets.templateData.templateMappingColumns = list;
    return true;
  }

  passDataToDetails() {
    if (this.importDocumentsService.submit) {
      this.isRecall = false;

      if (!this.prepareMappingData()) return;

      this.importDocumentsService.dataPassAccordingToTrackingBar.next(this.insertUpdateImportDocumnets);

      // Call the import API directly based on current tab/route and advance to the next step
      this.callImportApi(true);
    } else {
      this.importDocumentsService.mapValidation.next(false);
      this.toaster.error("Please insert required field");
    }
  }

  /**
   * Calls the appropriate import API based on current tab/route.
   * On success, pushes the response and optionally advances to the next step.
   */
  private callImportApi(advanceStep: boolean = true): void {
    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      this.submitCodeCrosswalk(advanceStep);
    } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
      this.submitBom(advanceStep);
    } else {
      this.submitCompanyOrVendor(advanceStep);
    }
  }

  private submitCompanyOrVendor(advanceStep: boolean): void {
    if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      this.insertUpdateImportDocumnets.isVendor = true;
    }

    this.insertUpdateImportDocumnets.templateData.sourceId = this.router.url.includes('import-companies') ? 1 : 2;

    const payload = { ...this.insertUpdateImportDocumnets };
    delete payload.importCodeCrosswalkModel;

    this.importDocumentsService.InsertImportCompanyData(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId = res?.response?.moduleData?.templateId ?? '0';
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advanceStep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        // this.toaster.error('Failed to import data.');
      }
    });
  }

  private submitCodeCrosswalk(advanceStep: boolean): void {
    this.insertUpdateImportDocumnets.templateData.sourceId = 3;

    const payload = { ...this.insertUpdateImportDocumnets };
    delete payload.isVendor;
    delete payload.importCompanyModel;

    this.importDocumentsService.InsertImportCodeCrosswalkTemplate(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId = res?.response?.moduleData?.templateId ?? '0';
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advanceStep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        this.toaster.error('Failed to import data.');
      }
    });
  }

  private submitBom(advanceStep: boolean): void {
    this.insertUpdateImportDocumnets.templateData.sourceId = 9;

    const payload = { ...this.insertUpdateImportDocumnets };
    delete payload.isVendor;
    delete payload.importCompanyModel;
    delete payload.importCodeCrosswalkModel;

    this.importDocumentsService.InsertImportBOMTemplate(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.insertUpdateImportDocumnets.importModel.mappingTemplateId = res?.response?.templateId ?? '0';
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advanceStep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        this.toaster.error('Failed to import data.');
      }
    });
  }

  onSelectionChanged($event) { }


  closeTab() {
    if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      this.importDocumentsService.closeVendorTab();
      this.router.navigate([this.routePath.VENDORLIST_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.VENDORLIST_TAB)
    } else if (this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH) {
      this.importDocumentsService.closeBOMTab();
      this.router.navigate([this.routePath.REQUIREMENT_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.REQUIREMENTS_TAB)
    } else {
      this.importDocumentsService.closeTab();
      this.router.navigate([this.routePath.COMPANY_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.COMPANY_TAB)
    }
  }

  autoMapColumns() {
    if (this.unmappedUploadedColumns?.length) {
      const unmappedColumnsData = this.unmappedUploadedColumns.map(column => ({
        systemColumn: column
      }));
      const data = { unmappedColumns: unmappedColumnsData };
      this.sendDataService.openModalPopup(UnmappedPopUpComponent, data, 'Unmapped Headers', ModalPopupSize.LG, 'markAsAddEditAddress has-parent-popup');
    }
  }
  openTemplateSettingModal() {
    let fileName = '';
    this.importDocumentsService.fileName.subscribe((res) => {
      if (res) {
        fileName = res;
      }
    });

    const modalData = {
      insertUpdateImportDocumnets: this.insertUpdateImportDocumnets,
      currentTab: this.currentTab,
      routeUrl: this.routeUrl,
      fileName: fileName,
    };

    this.sendDataService.openModalPopup(
      DetailsTabComponent,
      modalData,
      'Template Settings',
      ModalPopupSize.LG,
      'markAsAddEditAddress has-parent-popup'
    ).then((resultData) => {
      if (resultData?.confirm && resultData?.templateData) {
        this.insertUpdateImportDocumnets.templateData.templateName = resultData.templateData.templateName;
        this.insertUpdateImportDocumnets.templateData.templateDescription = resultData.templateData.templateDescription;
        this.insertUpdateImportDocumnets.templateData.isTemplateCreate = resultData.templateData.isTemplateCreate;
        this.insertUpdateImportDocumnets.importCompanyModel.mappingTemplateId = resultData.templateData.mappingTemplateId;
        this.insertUpdateImportDocumnets.importCodeCrosswalkModel.mappingTemplateId = resultData.templateData.mappingTemplateId;
        this.insertUpdateImportDocumnets.importModel.mappingTemplateId = resultData.templateData.mappingTemplateId;
        if (!this.importDocumentsService.submit) {
          this.importDocumentsService.mapValidation.next(false);
          this.toaster.error("Please insert required field");
          return;
        }

        if (!this.prepareMappingData()) return;
        this.callImportApi(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}